module.exports = __webpack_public_path__ + "static/media/heartActive.aa5f5e80.svg";